module.exports = __webpack_public_path__ + "static/media/phone_background.023098bc.png";